import React from "react";
import { Text, StyleSheet, View, Platform } from "react-native";

import AppTheme from "../../../AppTheme";
import ManaMinutesDuration from "../../../common/ManaMinutesDuration";

export default function ComparisonHours({ minutes, label, suffix, style = {} }) {
  return (
    <View style={styles.container}>
      {label ? <Text style={styles.label}>{label}</Text> : null}
      <ManaMinutesDuration
        minutes={minutes}
        suffix={suffix}
        disableWarnings
        showZero
        style={style}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 105,
    alignItems: "flex-start",
  },
  label: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginBottom: 1,
  },
});
